import React, { Component } from 'react';
import {connect} from "react-redux";
import AppSidebar from "../components/AppSidebar";
import PageHeader from "../components/PageHeader";
import PanelGroupController from "../components/PanelGroupController";
import ReferralCodesList from "./views/ReferralCodesList";
import ReferralCodePropertiesPanel from "./panels/ReferralCodePropertiesPanel";
import ActionButton from "../components/ActionButton";
import {requestCreateReferralCode, requestEditReferralCode} from "../actions/SalesApiActions";
import {List} from "immutable";

class ReferralCodesPage extends Component {

  constructor(props) {
    super(props);
    this.handleSetSelection = this.handleSetSelection.bind(this);
    this.state = {
      code: "",
      hasSelection: false,
    }
  }

  componentDidMount() {
  }

  render() {
    const page = this.props.route.page || "referrals";
    let view = this.renderView(page);
    let panels = this.renderPanels(page);

    let title = "Referral Codes";

    return (
      <div className="ReferralCodesPage SecurePage">
        <AppSidebar />
        <PageHeader title={title} />
        <div className="PageContainer">
          {view}
        </div>
        <div className="PanelContainer">
          <div className="header" />
          {panels}
          <PanelGroupController title="Actions">
            <ActionButton
              label="Create Code"
              onClick={this.handleCreateCode.bind(this)} />
            <ActionButton
              label="Edit Code"
              active={this.state.hasSelection}
              onClick={this.handleEditCode.bind(this)} />
            <ActionButton
              label="View Customers"
              active={this.state.hasSelection}
              onClick={this.handleViewCustomers.bind(this)} />
          </PanelGroupController>
        </div>
      </div>
    );
  }

  renderView(page) {
    return (
      <ReferralCodesList 
        selectedId={this.state.code} 
        onSelectionChange={this.handleSetSelection}
        />
    )
  }


  renderPanels(page) {
    return this.buildPanels(List([ReferralCodePropertiesPanel]));
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    switch(component) {
      case ReferralCodePropertiesPanel:
        return <ReferralCodePropertiesPanel
                key="ReferralCodePropertiesPanel"
                expanded={true}
                code={this.state.code}
                hasSelection={this.state.hasSelection}
                />
      default:
        return null;      
    }
  }

  handleSetSelection(id) {
    this.setState({code: id, hasSelection: true});
  }

  handleCreateCode() {
    this.props.requestCreateReferralCode();
  }

  handleEditCode() {
    this.props.requestEditReferralCode(this.state.code);
  }

  handleViewCustomers() {
    this.props.router.push({pathname: "/customers", query: {referralCode: this.state.code}});
  }

}

export default connect(null, {requestCreateReferralCode, requestEditReferralCode})(ReferralCodesPage);
